import React from 'react';
import './DashboardPage.scss';
import Dashboard from '../../Dashboard/Dashboard';
import {useHistory, Redirect} from "react-router-dom";
import { useSelector } from "react-redux";

const DashboardPage = () => {
  const history = useHistory();
  const state = useSelector((state) => state);
  const auth = useSelector((state) => state.auth);
  const bodyElement = document.querySelector("body");

  if(auth && auth.user && (auth.user.role === "PRIVATE" || auth.user.role === "COMPANY") && auth.auth_issuer==="SPID" && state.contracts.list.length === 0 && !auth.skipSpid){
    return <Redirect to='/contracts/add-spid'/>;
  }

  if (bodyElement && bodyElement.querySelectorAll("success-modal-container").length === 0) {
    bodyElement.classList.remove("modal-open");
  }

  return(
    <div className="DashboardPage" data-testid="DashboardPage">
      <Dashboard />
    </div>
  );
 
};





DashboardPage.propTypes = {};

export default DashboardPage;
